import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import { LoadableAfterPaint, type LoadableType } from '@confluence/loadable';

export const SmartButtonLoader: LoadableType<
	Omit<
		{
			flags: FlagsStateContainer;
			smartButtonName?: string;
			ruleId?: string;
			scopeId?: string;
			pageAri?: string;
			site?: string;
			isViewMode: boolean;
			contentType: string;
			experienceTrackerName: string;
			contentId: string;
			predefinedTemplateId?: string;
		},
		'flags'
	>
> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SmartButton" */ '../SmartButton.tsx')).SmartButton,
});
